import { getTotalDetail, getTotalList, initiateOpening } from '@/services/accountProcess/google/total'
import { getReviewDetail, getReviewList, exportReviewList } from '@/services/accountProcess/google/review'
import { getMccDetail, getMccList } from '@/services/accountProcess/google/mcc'
import { read } from '@/utils/request'

export type GoogleProcessPageType = 'total' | 'review' | 'mcc' | ''

const listService = {
  total: getTotalList,
  review: getReviewList,
  mcc: getMccList,
}

const exportService = {
  total: getTotalList,
  review: exportReviewList,
  // review: getReviewList,
  mcc: getMccList,
}


const detailService = {
  total: getTotalDetail,
  review: getReviewDetail,
  mcc: getMccDetail,
}

const createService = {
  total: initiateOpening,
  review: initiateOpening,
  mcc: initiateOpening,
}

const getTimeZone = () => {
  return read<{ key: string, value: string }[]>('gg_account_opening/get_time_zone', undefined, '获取时区失败')
}

const getTimeZoneSelects = async () => {
  const [ res ] = await getTimeZone()
  return res?.map(({ key, value }) => ({ value: key, title: value }))
}


export {
  listService,
  exportService,
  detailService,
  createService,
  getTimeZoneSelects,
}
